export default "__VITE_ASSET__gTUTAhZo__"